import { ClientBillingModel } from './../human-resource/client-billing/client-billing.model';
import { Injectable } from '@angular/core';
import { AppAPIConfig } from './app-api-config';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HumanResourceService {
  appApi = new AppAPIConfig();
  httpOptions = {};
  httpOptionsForDelete: any;
  httpOptionsForExportToExcel: {};

  //userId = localStorage.getItem('userid');

  constructor(private http: HttpClient) {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      // observe: 'response'
    };

    this.httpOptionsForDelete = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      body: {},
    };

    this.httpOptionsForExportToExcel = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      responseType: 'blob'
    };
  }

  refreshHttpOptions() {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      // observe: 'response'
    };

    this.httpOptionsForDelete = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      body: {},
    };


    this.httpOptionsForExportToExcel = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      responseType: 'blob'
    };
  }

  // Profile
  getProfile(page, limit) {
    return this.http.get(
      this.appApi.profileAPI + '?page=' + page + '&limit=' + limit,
      this.httpOptions
    );
  }

  getManageProfile(page, limit) {
    return this.http.get(
      this.appApi.manageProfileAPI + '?page=' + page + '&limit=' + limit,
      this.httpOptions
    );
  }

  getOvertimeApplicabilityLookup() {
    return this.http.get(this.appApi.overtimeApplicabilityAPI, this.httpOptions);
  }

  getProfiles() {
    return this.http.get(this.appApi.profileAPI, this.httpOptions);
  }

  getEmployeeProfile(empType) {
    return this.http.get(this.appApi.employeeProfileAPI + '/' + empType, this.httpOptions);
  }

  // getProfileByName(name) {
  //   return this.http.get(
  //     this.appApi.profileAPI + '/name?name=' + name,
  //     this.httpOptions
  //   );
  // }
  getProfileByName(name: string, profileStatus?: boolean | null) {

  let params: any = {
    name: name
  };

  if (profileStatus !== null && profileStatus !== undefined) {
    params.profileStatus = profileStatus;
  }

  return this.http.get(
    this.appApi.profileAPI + '/name',
    {
      params,
      ...this.httpOptions
    }
  );
}

  deleteProfile(id) {
    return this.http.delete<any>(
      this.appApi.profileAPI + '/' + id,
      this.httpOptions
    );
  }
  deleteDoc(id) {
    return this.http.delete<any>(
      this.appApi.profileAPI + '/docs/' + id,
      this.httpOptions
    );
  }

  saveProfile(body) {
    return this.http.post<any>(this.appApi.profileAPI, body, this.httpOptions);
  }

  viewProfile(id) {
    return this.http.get(this.appApi.profileAPI + '/' + id, this.httpOptions);
  }

  updateProfile(body, employeeUserId) {
    return this.http.put<any>(
      this.appApi.profileAPI + '/' + employeeUserId,
      body,
      this.httpOptions
    );
  }

  getLookupForManageProfile() {
    return this.http.get(this.appApi.profileAPI + '/lookups', this.httpOptions);
  }

  getQualificationsLookup() {
    return this.http.get(this.appApi.qualificationAPI, this.httpOptions);
  }

  getServiceVerticalLookup() {
    return this.http.get(this.appApi.serviceVerticalAPI, this.httpOptions);
  }


  getClientByDate(userId, fromDate, toDate) {
    return this.http.get(this.appApi.userByDateAPI + '/' + userId + '/' + fromDate + '/' + toDate, this.httpOptions);
  }

  getProfilePhoto() {
    return this.http.get(
      this.appApi.profileAPI + '/photo/' + localStorage.getItem('userid'),
      this.httpOptions
    );
  }

  // uploadUserDocument(formData, type, userId) {
  //   console.log(formData.get('file'));
  //   var httpOptionsForUpload = {
  //     headers: new HttpHeaders({
  //       Authorization: localStorage.getItem('token'),
  //     }),
  //   };
  //   return this.http.post<any>(
  //     this.appApi.profileAPI + '/upload/' + type + '/' + userId,
  //     formData,
  //     httpOptionsForUpload
  //   );
  // }

  uploadUserDocumentList(formData, userId, docStatus, docType) {
    var httpOptionsForUpload = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
    };
    return this.http.put<any>(
      this.appApi.profileAPI + '/upload/' + userId + '?docStatus=' + docStatus + '&docType=' + docType,
      formData,
      httpOptionsForUpload
    );
  }

  getUserDocuments(userId) {
    return this.http.get(
      this.appApi.profileAPI + '/docs/' + userId,
      this.httpOptions
    );
  }

  getClientsByBranch(id) {
    return this.http.get(
      this.appApi.clientByBranchAPI + '/branch/' + id,
      this.httpOptions
    );
  }

  getAssignmentByClient(id) {
    return this.http.get(
      this.appApi.assignmentByClientAPI + '/client/' + id,
      this.httpOptions
    );
  }

  getClientBillingReport(clientid, assignid) {
    return this.http.get<ClientBillingModel[]>(
      this.appApi.clientBillingReportAPI + '/' + clientid + '/' + assignid,
      this.httpOptions
    );
  }

  getClientBillingReportExcel(clientId,assignid){
    return this.http.get<ClientBillingModel[]>(
      this.appApi.clientBillingReportExcelAPI + '/' + clientId + '/' + assignid,
      this.httpOptionsForExportToExcel
    );
  }

  getGenerateBill(clientid, assignid) {
    return this.http.post<any>(
      this.appApi.generateBillAPI + '/' + clientid + '/' + assignid,
      {},
      this.httpOptions
    );
  }

  getClientBillingDate(clientId, fyId) {
    return this.http.get<any>(
      this.appApi.generateClientBillAPI + '/' + clientId + '/' + fyId,
      this.httpOptions
    );
  }

  getClientConveyanceReport(clientId, clientBillingDateId, fyId) {
    return this.http.get<any>(
      this.appApi.clientConveyanceReportAPI +
      '/' +
      clientId +
      '/' +
      clientBillingDateId +
      '/' +
      fyId,
      this.httpOptions
    );
  }

  getClientConveyanceReportExportToExcel(clientId, clientBillingDateId, fyId) {
    console.log('options=', this.httpOptionsForExportToExcel);
    return this.http.get<any>(
      this.appApi.clientConveyanceReportExportToExcelAPI +
      '/' +
      clientId +
      '/' +
      clientBillingDateId +
      '/' +
      fyId,
      this.httpOptionsForExportToExcel
    );
  }

  getClientByBilledConveyanceReport(clientId, clientBillingDateId) {
    return this.http.get<any>(
      this.appApi.clientByBilledConveynceReportAPI +
      '/' +
      clientId +
      '/' +
      clientBillingDateId,
      this.httpOptions
    );
  }

  getClientByBilledConveyanceExportToExcelReport(clientId, clientBillingDateId) {
    return this.http.get<any>(
      this.appApi.clientByBilledConveynceReportExportToExcelAPI +
      '/' +
      clientId +
      '/' +
      clientBillingDateId,
      this.httpOptionsForExportToExcel
    );
  }

  getClientByMonthlyConveyanceReport(
    clientId,
    clientBillingDateId,
    billingDateId,
    month,
    year
  ) {
    return this.http.get<any>(
      this.appApi.clientByMonthlyConveyanceReportAPI +
      '/' +
      clientId +
      '/' +
      clientBillingDateId +
      '/' +
      billingDateId +
      '/' +
      month +
      '/' +
      year,
      this.httpOptions
    );
  }

  getClientByMonthlyConveyanceExcelToExportReport(clientId,
    clientBillingDateId,
    billingDateId,
    month,
    year) {
    return this.http.get<any>(
      this.appApi.clientByMonthlyConveyanceReportExportToExcelAPI +
      '/' +
      clientId +
      '/' +
      clientBillingDateId +
      '/' +
      billingDateId +
      '/' +
      month +
      '/' +
      year,
      this.httpOptionsForExportToExcel
    );
  }

  getClientConveyanceAssignmentReport(clientId, clientBillingDateId, fyId) {
    return this.http.get<any>(
      this.appApi.clientConveyanceAssignmentReportAPI +
      '/' +
      clientId +
      '/' +
      clientBillingDateId +
      '/' +
      fyId,
      this.httpOptions
    );
  }

  getClientConveyanceAssignmentReportExportToExcel(clientId, clientBillingDateId, fyId) {
    return this.http.get<any>(
      this.appApi.clientConveyanceAssignmentReportExportToExcelAPI +
      '/' +
      clientId +
      '/' +
      clientBillingDateId +
      '/' +
      fyId,
      this.httpOptionsForExportToExcel
    );
  }

  getClientByBilledConveyanceAssignmentReport(
    clientId,
    clientBillingDateId,
    assignmentId
  ) {
    return this.http.get<any>(
      this.appApi.clientByBilledConveynceAssignmentReportAPI +
      '/' +
      clientId +
      '/' +
      clientBillingDateId +
      '/' +
      assignmentId,
      this.httpOptions
    );
  }

  getClientByBilledConveyanceAssignmentExportToExcelReport(clientId, clientBillingDateId, assignmentId) {
    return this.http.get<any>(
      this.appApi.clientByBilledConveynceAssignmentExportToExcelReportAPI +
      '/' +
      clientId +
      '/' +
      clientBillingDateId +
      '/' +
      assignmentId,
      this.httpOptionsForExportToExcel
    );
  }

  getClientByMonthlyConveyanceAssignmentReport(
    clientId,
    closingDateId,
    clientBillingDateId,
    assignmentId,
    month,
    year
  ) {
    return this.http.get<any>(
      this.appApi.clientByMonthlyConveyanceAssignmentReportAPI +
      '/' +
      clientId +
      '/' +
      closingDateId +
      '/' +
      clientBillingDateId +
      '/' +
      assignmentId +
      '/' +
      month +
      '/' +
      year,
      this.httpOptions
    );
  }

  getClientByMonthlyConveyanceAssignmentExportToExcelReport(clientId,
    closingDateId,
    clientBillingDateId,
    assignmentId,
    month,
    year) {
    return this.http.get<any>(
      this.appApi.clientByMonthlyConveyanceAssignmentExportToExcelReportAPI +
      '/' +
      clientId +
      '/' +
      closingDateId +
      '/' +
      clientBillingDateId +
      '/' +
      assignmentId +
      '/' +
      month +
      '/' +
      year,
      this.httpOptionsForExportToExcel
    );
  }

  getClientAssignmentByBillDate(clientId, billDateId) {
    console.log('billed date', billDateId);
    return this.http.get(
      this.appApi.assignmentByClientAPI + '/client/' + clientId + '/' + billDateId,
      this.httpOptions
    );
  }

  getReimbursementReportDetails(clientStatusId, clientId, billId, assignmentId) {
    return this.http.get<any>(
      this.appApi.reimbursementReportAPI +
      '/' +
      clientStatusId
      + '/' +
      clientId +
      '/' +
      billId +
      '?assignmets=' +
      assignmentId,
      this.httpOptions
    );
  }

  getReimbursementReportExcel(clientStatusId, clientId, billId, assignmentId) {
    return this.http.get<any>(
      this.appApi.reimbursementReportExcelAPI +
      '/' +
      clientStatusId
      + '/' +
      clientId +
      '/' +
      billId +
      '?assignmets=' +
      assignmentId,
      this.httpOptionsForExportToExcel
    );
  }

  getBranchByEmpProfile(userId) {
    return this.http.get<any>(
      this.appApi.branchByEmployeeAPI +
      '/' + userId,
      this.httpOptions
    );
  }

  getClientsByEmployee(userId) {
    return this.http.get<any>(
      this.appApi.clientByEmployeeAPI +
      '/' + userId,
      this.httpOptions
    );
  }

  getAssignmentsByMultipleClient(userId, clientId) {
    return this.http.get<any>(
      this.appApi.assignmentsByClientsAPI +
      '/' + userId + '?clientId=' + clientId,
      this.httpOptions
    );
  }

  getClientsByEmployeeAndStatus(empId, status) {
    return this.http.get<any>(
      this.appApi.clientsByEmpAndStatusAPI +
      '/' + empId + '/' + status,
      this.httpOptions
    );
  }

  getClientsByFY(userId,fyId){
    return this.http.get<any>(
      this.appApi.clientsByEmpAndStatusAPI +
      '/' + userId + '/fy/' + fyId,
      this.httpOptions
    );
  }

  getArticleshipTenure(icaiRegistrationDate){
    return this.http.get<any>(
      this.appApi.articleTenureAPI + '?registrationDate=' + icaiRegistrationDate,
      this.httpOptions
    );
  }

}


@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  private profileSubject = new Subject();
  sendProfile() {
    console.log('inside send profile')
    this.profileSubject.next();
  }

  getprofile(): Observable<any> {
    console.log('inside get profile')
    return this.profileSubject.asObservable();
  }

}